import "core-js/modules/es.array.push.js";
import "/public/css/goods.css";
import { computed, ref, onMounted, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import httpRequest from '@/request/index';
import { showLoadingToast, showFailToast, closeToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const checkedGoods = ref([]);
    const checkGoodsGroup = ref(null);
    const checkedAll = ref(true);
    const router = useRouter();
    const goodsList = ref({});
    const isShow = ref(false);
    const editCart = (value, detail) => {
      store.dispatch("editCart", {
        id: detail.name,
        count: value
      });
    };
    const delCart = (id, no) => {
      console.log(checkedGoods.value);
      if (cartList.value[id].count < no) {
        store.dispatch("editCart", {
          id: id,
          count: 0
        });
      }
    };
    const checkAll = e => {
      checkGoodsGroup.value.toggleAll(e);
    };
    const onSubmit = () => {
      console.log("提交订单");
      localStorage.setItem('buyGoods', JSON.stringify(checkedGoods.value));
      router.push("/submit");
    };
    const goBack = () => {
      router.go(-1);
    };
    let cartList = computed(() => {
      let list = store.state.cartItem;
      return list;
    });
    let submitBarText = computed(() => {
      const count = checkedGoods.value.length;
      return '提交订单' + (count ? `(${count})` : '');
    });
    let totalPrice = computed(() => {
      let total = 0;
      if (isShow.value) {
        for (var i = checkedGoods.value.length - 1; i >= 0; i--) {
          if (cartList.value[checkedGoods.value[i]]) {
            total += goodsList.value[checkedGoods.value[i]].price * cartList.value[checkedGoods.value[i]].count * 100;
          } else {
            checkedGoods.value.splice(i, 1);
          }
        }
      }
      return total;
    });
    onBeforeMount(() => {
      document.getElementsByTagName("body")[0].className = "bg_body";
    });
    onBeforeUnmount(() => {
      document.body.removeAttribute("class", "bg_body");
    });
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      showLoadingToast({
        message: '加载中',
        forbidClick: true
      });
      let goodsId = "0";
      for (let key in cartList.value) {
        goodsId += "," + cartList.value[key].id;
        checkedGoods.value.push(cartList.value[key].id);
      }
      await httpRequest({
        method: "get",
        url: "?file=goods&act=list&id=" + goodsId
      }).then(res => {
        closeToast();
        if (res.state == 1) {
          goodsList.value = res.list;
          isShow.value = true;
        } else {
          showFailToast(res.msg);
        }
      });
    });
    return {
      goBack,
      cartList,
      editCart,
      delCart,
      checkedGoods,
      submitBarText,
      totalPrice,
      checkedAll,
      checkAll,
      checkGoodsGroup,
      onSubmit,
      goodsList,
      isShow
    };
  }
};